const reassembleChunks = (count, getChunk) => {
  let assembled = '';
  for (let i = 0; i < count; i += 1) {
    const chunk = getChunk(i);
    if (!chunk) {
      return undefined;
    }
    assembled += chunk;
  }
  return assembled;
};

const readChunkedCookie = (cookieName, getRaw) => {
  const countStr = getRaw(`${cookieName}_count`);

  if (!countStr) {
    return getRaw(cookieName);
  }

  // eslint-disable-next-line radix
  const count = parseInt(countStr, 10);
  if (Number.isNaN(count) || count <= 0) {
    return getRaw(cookieName);
  }

  const assembled = reassembleChunks(count, i => getRaw(`${cookieName}_${i}`));
  if (assembled === undefined) {
    console.error(`[cookies] Missing cookie chunk: ${cookieName}`);
  }
  return assembled;
};

export { reassembleChunks, readChunkedCookie };
